import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSession } from "../features/auth";
import LoadingIndicator from "../components/LoadingIndicator";
import SignIn from "./sign-in";
import AuthLayout from "./auth";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import AppRoutes from '../constants/Routes'

const Index = () => {

    const { status, isLoading, session } = useSession();


    const { i18n } = useTranslation();

    useEffect(() => {
        document.documentElement.setAttribute('dir', i18n.dir()); // Set the dir attribute
    }, [i18n.language]);


    if (isLoading) {
        return <LoadingIndicator />
    }

    if (!session) {
        return <SignIn />
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<AuthLayout />}>
                    {AppRoutes.map((route) => {
                        if (route.href === "/") {
                            return <Route key={route.label} index element={route.element} />
                        }
                        return <Route key={route.label} path={route.href} element={route.element} />
                    })}
                    <Route path="*" element={<Navigate to="/" />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default Index;